import { IconChevronLeftRegular, IconChevronRightRegular, PageBullets, skinVars } from '@telefonica/mistica';
import './index.scss';

interface BillsPageBulletsType {
    debt: boolean;
    charSlide: number;
    bulletPointsClickHandler: (index: number) => void;
    numPages: number;
    arrowHandler: (value: boolean) => void;
}

const BillsPageBullets = ({
    debt,
    charSlide,
    bulletPointsClickHandler,
    numPages,
    arrowHandler,
}: BillsPageBulletsType) => {
    return (
        <div className='bills-bullet-page' style={{ marginBottom: !debt ? '16px' : '0px' }}>
            <div className='bills-bullet-page__svg' onClick={() => arrowHandler(true)}>
                <IconChevronLeftRegular size={24} color={skinVars.colors.brand} />
            </div>

            <PageBullets numPages={numPages} currentIndex={charSlide} onPress={bulletPointsClickHandler} />

            <div className='bills-bullet-page__svg' onClick={() => arrowHandler(false)}>
                <IconChevronRightRegular size={24} color={skinVars.colors.brand} />
            </div>
        </div>
    );
};

export default BillsPageBullets;
